import React from 'react';
import TextareaAutosize from 'react-textarea-autosize';
import TransitionBlock from '../TransitionBlock'
import { formatBezierCurveCSS } from '../../utils';
import './allBlock.scss';

export default class AllBlock extends React.Component {
        
    onFocus = () => {
        const {onEditModeChange, staticView} = this.props;
        if(!staticView) {
            onEditModeChange(true);
        }
    }

    onBlur = () => {
        const {onEditModeChange, staticView} = this.props;
        if(!staticView) {
            onEditModeChange(false);
        }
    }

	render() {
		const { copy, fontOptions, transitionOptions, onChange, staticView } = this.props;
        const bezierCurve = formatBezierCurveCSS(transitionOptions.bezierCurve);
                
		return (
            <TransitionBlock
                {...transitionOptions}
                triggerOnce
                from={transitionOptions.direction}
                delay={300}
                animateOpacity={transitionOptions.opacity}
                duration={transitionOptions.duration}
                offset={`${transitionOptions.offset}px`}
                transition={bezierCurve}
                underline={fontOptions.underline}
            >
                <div
                    style={{
                        fontFamily: fontOptions.customFont ? `'${fontOptions.customFont}'` : fontOptions.family,
                        fontWeight: fontOptions.fontWeight,
                        fontSize: `${fontOptions.size}px`,
                        color: staticView ? 'white' : fontOptions.color,
                        lineHeight: `${fontOptions.lineHeight}px`,
                        letterSpacing: `${fontOptions.letterSpacing}em`,
                        maxWidth: `${fontOptions.maxWidth}px`,
                        width: `${fontOptions.maxWidth}px`,
                        pointerEvents: staticView ? 'none' : 'normal'
                    }}
                >
                    <TextareaAutosize
                        className={`${staticView ? 'static' : ''}`}
                        onFocus={this.onFocus}
                        onBlur={this.onBlur}
                        value={copy}
                        placeholder="Enter your wittiest copy."
                        onChange={onChange}
                    />
                </div>
            </TransitionBlock>	
		);
	}
}